import { render, staticRenderFns } from "./ConnectionGroupsList.vue?vue&type=template&id=2928d081&scoped=true"
import script from "./ConnectionGroupsList.vue?vue&type=script&lang=js"
export * from "./ConnectionGroupsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2928d081",
  null
  
)

export default component.exports